var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.23256 18C1.6186 18 1.09321 17.7799 0.656372 17.3396C0.218791 16.8986 0 16.3687 0 15.75V2.25C0 1.63125 0.218791 1.10175 0.656372 0.6615C1.09321 0.2205 1.6186 0 2.23256 0H8.93023L11.1628 2.25H20.093C20.707 2.25 21.2327 2.4705 21.6703 2.9115C22.1072 3.35175 22.3256 3.88125 22.3256 4.5H10.2419L8.0093 2.25H2.23256V15.75L4.91163 6.75H24L21.1256 16.3969C20.9767 16.8844 20.7025 17.2736 20.3029 17.5646C19.9025 17.8549 19.4605 18 18.9767 18H2.23256ZM4.57674 15.75H18.9767L20.986 9H6.58605L4.57674 15.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.603dbdc0e2cc6c7b16833082e6cdda5a.svg";
export { ForwardRef as ReactComponent };